 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERPAGE from '@/components/coverpage'
 import EBB from '@/components/ebb'
 import PORTALISTAD_1 from '@/components/portalistad_1'
 import TITLE from '@/components/title'
 import FOR_MY_MOTHER from '@/components/For_my_mother'
 import ELEGY_FOR_SABINA from '@/components/Elegy_for_Sabina'
 import CONTENTS from '@/components/contents'
 import CH_01 from '@/components/ch_01'
 import CH_02 from '@/components/ch_02'
 import CH_03 from '@/components/ch_03'
 import CH_04 from '@/components/ch_04'
 import CH_05 from '@/components/ch_05'
 import CH_06 from '@/components/ch_06'
 import CH_07 from '@/components/ch_07'
 import CH_08 from '@/components/ch_08'
 import CH_09 from '@/components/ch_09'
 import CH_10 from '@/components/ch_10'
 import COPYRIGHT from '@/components/copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/coverpage",
 			"name" : "coverpage",
 			"component" : COVERPAGE
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/portalistad_1",
 			"name" : "portalistad_1",
 			"component" : PORTALISTAD_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/For_my_mother",
 			"name" : "For_my_mother",
 			"component" : FOR_MY_MOTHER
 		},
 		{
 			"path" : "/Elegy_for_Sabina",
 			"name" : "Elegy_for_Sabina",
 			"component" : ELEGY_FOR_SABINA
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/ch_01",
 			"name" : "ch_01",
 			"component" : CH_01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js